import { render, staticRenderFns } from "./TypeSpotFolderDialog.vue?vue&type=template&id=04faac06&"
import script from "./TypeSpotFolderDialog.vue?vue&type=script&lang=js&"
export * from "./TypeSpotFolderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports